import { useEffect, useState } from "react";

/**
 * Fixed top-of-viewport indicator shown when the page is loaded inside the
 * Builder editor preview iframe (or via a shared preview link). Returns null
 * outside preview mode and on the SSR pass to avoid a hydration mismatch.
 *
 * The check is inlined (not via `isPreviewing` from the Builder SDK) so this
 * component — which mounts on every storefront page from the root — does not
 * pull the SDK into the root chunk for non-Builder routes.
 */
export function BuilderPreviewBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(window.location.search.includes("builder.preview="));
  }, []);

  if (!show) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="builder-preview-banner"
      className="pointer-events-none fixed left-1/2 top-2 z-[100] -translate-x-1/2 rounded-full bg-yellow-400 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-black shadow-lg"
    >
      Builder Preview Mode
    </div>
  );
}
